import React from 'react';
import PropTypes from 'prop-types';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

const {
  MarkerWithLabel
} = require("react-google-maps/lib/components/addons/MarkerWithLabel");

const propTypes = {
  orderPoints: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  })),
  centerCoordinates: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  isMarkerShown: PropTypes.bool,
  driverLocation: PropTypes.string,
  googleMapURL: PropTypes.string,
  loadingElement: PropTypes.node,
  containerElement: PropTypes.node,
  mapElement: PropTypes.node,
};

const defaultProps = {
  orderPoints: {},
  centerCoordnates: {},
  isMarkerShown: false,
  driverLocation: '',
  googleMapURL: '',
  loadingElement: null,
  containerElement: null,
  mapElement: null,
};

const DispatchMap = withScriptjs(withGoogleMap(({
  orderPoints,
  centerCoordinates,
  isMarkerShown,
  driverLocation,
}) => {
  // extends bounds to accomodate all coordinates
  const bounds = new window.google.maps.LatLngBounds();

  const driverLat = driverLocation.split(',')[0];
  const driverLng = driverLocation.split(',')[1];
  const car = {
    url: "http://maps.google.com/mapfiles/kml/pal4/icon15.png",
    size: new google.maps.Size(32, 32),
  };

  if (orderPoints.length > 0) {
    orderPoints.map((point) => {
      const { lat, lng } = point;
      const latLng = new window.google.maps.LatLng(lat, lng);
      bounds.extend(latLng);
    });
  }
  /* fitBounds: used to center the map view
   * panTo: used to set a default location when
   *        there are no location points
   */
  const mapRef = (map) => {
    if (map) {
      map.fitBounds(bounds);
      if (orderPoints.length === 0) {
        map.panTo(centerCoordinates);
      }
    }
  };
  return (
    <GoogleMap
      ref={mapRef}
      zoom={8}
      center={centerCoordinates}
      options={{ maxZoom: 17 }}
    >
      {
        isMarkerShown &&
          orderPoints.map(point => (
            <MarkerWithLabel
              key={point.ActiveStopNum}
              position={{ lat: point.lat, lng: point.lng }}
              labelAnchor={new google.maps.Point(0, 0)}
              labelStyle={{ backgroundColor: 'white', fontSize: '14px' }}
            >
              <div>{point.deliver_eta_info.duration_text}</div>
            </MarkerWithLabel>
          ))
      }
      {
        isMarkerShown &&
          orderPoints.map(point => (
            <Marker
              key={point.ActiveStopNum}
              label={String(point.ActiveStopNum)}
              position={{ lat: point.lat, lng: point.lng }}
            />
          ))
      }
      {
        <Marker
          key={1}
          label={1}
          position={{ lat: Number(driverLat), lng: Number(driverLng) }}
          icon={car}
        />
      }
    </GoogleMap>
  );
}));

DispatchMap.propTypes = propTypes;
DispatchMap.defaultProps = defaultProps;

export default DispatchMap;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/DispatchMap.jsx